// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"433":"d7556e60","1154":"344197db","9096":"344197db"}[chunkId] + ".chunk.css";
};